import { IconProps } from 'atomic/icon/icon.interface';
import classNames from 'classnames';
import React from 'react';

import './icon.scss';

const Icon: React.FC<IconProps> = ({ name, color, size, title, className, onClick, ...rest }) => {
    const classes = classNames(
        {
            ['skp-ico']: true,
            [`skp-ico--color-${color}`]: !!color,
            [`skp-ico--size-${size}`]: !!size,
            [`skp-ico-${name}`]: !!name,
            [`${className}`]: !!className,
            ['skp-ico--clickable']: onClick
        }
    );

    return React.createElement('i', {
        title,
        className: classes,
        onClick,
        ...rest
    });
};

export default Icon;
